"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorDisplayListScrollable_1 = require("./errorDisplayListScrollable");
//Errors will be scrolled into view whenever a NEW INSTANCE of Props.errors is provided (and it actually has errors) 
var ErrorDisplayListAutoScrolling = /** @class */ (function (_super) {
    __extends(ErrorDisplayListAutoScrolling, _super);
    function ErrorDisplayListAutoScrolling(props) {
        var _this = _super.call(this, props) || this;
        _this.getPropertyErrors = function () {
            return _this.isPropertyErrors(_this.props.errors) ? _this.props.errors : _this.props.errors.getPropertyErrors();
        };
        _this.doneScrolling = function () {
            _this.setState({
                shouldScroll: false
            });
        };
        _this.state = {
            shouldScroll: !!_this.getPropertyErrors().length
        };
        return _this;
    }
    ErrorDisplayListAutoScrolling.prototype.componentDidUpdate = function (prevProps) {
        if (!this.getPropertyErrors().length || prevProps.errors == this.props.errors)
            return;
        this.setState({
            shouldScroll: true
        });
    };
    ErrorDisplayListAutoScrolling.prototype.render = function () {
        var errors = {
            errors: this.getPropertyErrors(),
            shouldScroll: this.state.shouldScroll
        };
        return React.createElement(errorDisplayListScrollable_1.ErrorDisplayListScrollable, { errors: errors, doneScrolling: this.doneScrolling });
    };
    ErrorDisplayListAutoScrolling.prototype.isPropertyErrors = function (errors) {
        return (errors instanceof Array);
    };
    return ErrorDisplayListAutoScrolling;
}(React.PureComponent));
exports.ErrorDisplayListAutoScrolling = ErrorDisplayListAutoScrolling;
